import {Component, Input} from '@angular/core';

@Component({
  selector: 'brt-level-label',
  templateUrl: './level-label.component.html',
  styleUrls: ['./level-label.component.scss']
})
export class LevelLabelComponent {
  @Input('level') set setLevel(val: number) {
    switch (val) {
      case 2:
        this.levelTitle = "Mäßige Übereinstimmung";
        break;
      case 3:
        this.levelTitle = "Hohe Übereinstimmung";
        break;
      default:
        this.levelTitle = "Geringe Übereinstimmung";
    }
  }

  levelTitle = "";
}
